module.exports = __webpack_public_path__ + "static/media/logo.30044d27.svg";